import Vue from 'vue';

export default Vue.extend<any, any, any, any>({
  data() {
    return {
      pointer: 0,
    };
  },
  methods: {
    pointerForward(options: any[]) {
      if (this.pointer < options.length-1) {
        this.pointer++;
        if (options[this.pointer].disabled) {
          this.pointerForward(options);
        }
      }
    },
    pointerBackward(options: any[]) {
      if (this.pointer > 0) {
        this.pointer--;
        if (options[this.pointer].disabled) {
          this.pointerBackward(options);
        }
      }
    },
    pointerSelect(options: any[]) {
      this.select(options[this.pointer]);
    },
    pointerOptionHover(index: number) {
      this.pointer = index;
    },
  },
});
